import type { VoucherDistributionConfig } from "../types/voucher-distribution-config";

export type VoucherDistribution = {
  id: number;
  name: string;
  slug: string;
  simplifiedRegistrationAvailable: boolean;
  rulesAcceptanceRequired: boolean;
  freePackagesEnabled: boolean;
  friendsAndFamilyEnabled: boolean;
  purchaseProductsEnabled: boolean;
  startsAt: string;
  endsAt: string;
  contractorLogoUrl?: string;
  consultations: {
    isEnabled: boolean;
    path: string;
    imageUrl: string;
  };
  configs: VoucherDistributionConfig[];
};

export const getConfig = (
  voucherDistribution?: VoucherDistribution,
  configName?: string,
): VoucherDistributionConfig | undefined => {
  if (!voucherDistribution || !configName) return undefined;

  return voucherDistribution?.configs.find((config) => config.configName === configName);
};
